import { memo, useMemo } from 'react';

import { Alert } from '@zillow/constellation-10';

import { useSelector } from '../../selectors/useSelector';

type Props = {
  contactEmail: string;
};

const ContactEmailMismatchAlert = ({ contactEmail }: Props): JSX.Element | null => {
  const { email: userEmail } = useSelector((state) => state.user);

  const { lowercaseUserEmail, lowercaseContactEmail } = useMemo(
    () => ({
      lowercaseUserEmail: userEmail?.toLowerCase(),
      lowercaseContactEmail: contactEmail?.toLowerCase(),
    }),
    [userEmail, contactEmail],
  );

  if (lowercaseUserEmail === lowercaseContactEmail) return null;

  return (
    <Alert data-testid="ContactEmailMismatchAlertContainer" tone="warning">
      This contact email differs from the one associated with your Zillow account.
    </Alert>
  );
};

export default memo(ContactEmailMismatchAlert);
